/**
 * Age selector component for age-adaptive UI initialization
 */

import React from 'react';
import { HomeIcon } from './SvgConsolidated/SvgIcons';

interface AgeSelectorProps {
  onAgeSelected: (age: number) => void;
  onReturnToHome?: () => void;
}

export default function AgeSelector({ onAgeSelected, onReturnToHome }: AgeSelectorProps) {
  const ageRanges = [
    { range: '5-6', label: 'Grade K-1', midpoint: 6 },
    { range: '7-8', label: 'Grade 2-3', midpoint: 8 },
    { range: '9-10', label: 'Grade 4-5', midpoint: 10 },
    { range: '11-12', label: 'Grade 6-7', midpoint: 12 },
    { range: '13-14', label: 'Grade 8-9', midpoint: 14 },
    { range: '15-18', label: 'Grade 10-12', midpoint: 17 },
  ];

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 max-w-xl w-full">
      {/* Home Button */}
      {onReturnToHome && (
        <div className="flex justify-start mb-4">
          <button
            onClick={onReturnToHome}
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            title="Return to Role Selection"
          >
            <HomeIcon className="w-4 h-4 mr-2" />
            Home
          </button>
        </div>
      )}
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Welcome to Your AI Voice Assistant!
        </h1>
        <p className="text-gray-600 text-lg">
          Please select your age range to get started with a personalized experience.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {ageRanges.map((ageRange) => (
          <button
            key={ageRange.range}
            onClick={() => onAgeSelected(ageRange.midpoint)}
            className="w-full p-4 text-lg font-semibold rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 text-white hover:from-blue-600 hover:to-purple-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            {ageRange.label}
          </button>
        ))}
      </div>

      <div className="mt-8 text-center">
        <p className="text-sm text-gray-500">
          This helps us customize the voice, language, and interface to match your preferences.
        </p>
      </div>
    </div>
  );
}